<template>
  <div class="subpage userInfo" ref="userInfo" style="background-color: #f7f7f7;">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" :is-sub-page="true" title="个人中心" callbackFun="goBack" @goBack="this.justGoBack" :is-return="false"></Header>
    <div ref="contentRef">
      <div class="bar head" @click="upload" style="position: relative;">
        <span class="bar-title">头像</span>
        <div class="head-arrow">
          <img v-if="avatar" class="headImg" :src="avatar"/>
          <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png" />
        </div>
        <cube-upload
          ref="avatarUpload"
          v-if="$route.query.platform === 'mini'"
          :action="uploadAction"
          :max="1"
          :multiple="false"
          :simultaneous-uploads="1"
          :process-file="processFile"
          @files-added="addedHandler"
          @file-success="handleMiniUpload"
          @file-submitted="fileSubmitted"/>
      </div>
      <div class="info-block">
        <div class="bar normal" @click="inputName">
          <span class="bar-title">用户名</span>
          <div>
            <span class="value">{{userName}}</span>
            <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png" />
          </div>
        </div>
        <div class="line"></div>
        <div class="bar normal" @click="showDatePicker">
          <span class="bar-title">生日</span>
          <div>
            <span class="value">{{birthday}}</span>
            <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png" />
          </div>
        </div>
        <div class="line"></div>
        <div class="bar normal" @click="showPicker">
          <span class="bar-title">性别</span>
          <div>
            <span class="value">{{sexValue}}</span>
            <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png" />
          </div>
        </div>
      </div>
      <router-link class="bar normal password" :to="{path: '/user/userInfo/modifyPassword', query:{platform: $route.query.platform, token: $route.query.token}}">
        <span class="bar-title">修改密码</span>
        <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png" />
      </router-link>
    </div>
    <router-view />

    <!--<div v-if="$route.query.platform === 'mini'" class="fixed-button">-->
    <div class="fixed-button">
      <div class="conversion-button safe-padding" @click="headGoBack">确认修改</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryUserDetail, updateUserInfo } from '@/api/user'

import compress from '@/utils/compress'

export default {
  name: '',
  data () {
    return {
      userName: '',
      birthday: '',
      sex: [{ value: '男', text: '男' }, { value: '女', text: '女' }],
      sexValue: '',
      avatar: '',
      avatarResId: '',
      bInit: false,
      uploadAction: null,
      loadingToast: null
    }
  },
  components: {
    Header
  },
  mounted () {
    if (this.$route.query.platform !== 'mini') {
      this.$dfzhJsBridge.setAddImageCallback(this.imageAdd)
    }
    this.init()

    this.uploadAction = {
      target: '/api/tools/update',
      headers: {
        Authorization: 'Bearer ' + this.$route.query.token
      },
      data: {
        typeCode: 'img'
      }
    }
  },
  beforeDestroy () {
    if (this.$route.query.platform !== 'mini') {
      this.$dfzhJsBridge.setAddImageCallback(null)
    }
  },
  methods: {
    showDatePicker () {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: '生日',
          min: new Date(1970, 1, 1),
          max: new Date(2020, 9, 20),
          value: new Date(),
          format: {
            year: 'yyyy',
            month: 'MM',
            date: 'DD'
          },
          onSelect: (date, selectedVal, selectedText) => {
            this.birthday = selectedText.join('-')
          },
          onCancel: () => {
          }
        })
      }
      this.datePicker.show()
    },
    showPicker () {
      if (!this.sexPicker) {
        this.sexPicker = this.$createPicker({
          title: '性别',
          data: [this.sex],
          onSelect: (date, selectedVal, selectedText) => {
            this.sexValue = selectedText[0]
          }
        })
      }
      this.sexPicker.show()
    },
    upload () {
      console.log('userInfo upload')
      if (this.$route.query.platform !== 'mini') {
        this.handleAppUpload()
      }
    },

    // 处理APP端上传头像
    handleAppUpload () {
      let ua = navigator.userAgent.toLowerCase()
      console.log('ua=' + ua)
      let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1
      // Ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
      console.log('isAndroid' + isAndroid + '  isIos=' + isiOS)
      if (isAndroid) {
        var inputObj = document.createElement('input')
        let frag = document.createDocumentFragment()
        let userInfo = document.querySelector('.userInfo')
        inputObj.setAttribute('id', 'file')
        inputObj.setAttribute('type', 'file')
        inputObj.setAttribute('name', 'file')
        inputObj.setAttribute('style', 'display:none')
        inputObj.setAttribute('accept', 'image/*')
        inputObj.setAttribute('title', '选取头像')
        //   inputObj.setAttribute('@change','previewFiles')
        // inputObj.value
        inputObj.addEventListener('click', function (e) {
          console.log(e, 'click')
        })
        frag.appendChild(inputObj)
        userInfo.appendChild(frag)
        inputObj.click()
      }
      this.$dfzhJsBridge.openFile()
    },

    // 处理小程序端上传头像
    addedHandler (file) {
      console.log(file)
      this.$refs.avatarUpload.removeFile(file)

      this.loadingToast = this.$createToast({
        time: 0,
        txt: '正在上传头像'
      }).show()
    },
    processFile (file, next) {
      compress(file, {
        compress: {
          width: 100,
          height: 100,
          quality: 0.5
        }
      }, next)
    },
    fileSubmitted (file) {
      file.file = this.base64ToFile(file.file.base64, 'avatar')
    },
    base64ToFile (urlData, fileName) {
      let arr = urlData.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bytes = atob(arr[1]) // 解码base64
      let n = bytes.length
      let ia = new Uint8Array(n)
      while (n--) {
        ia[n] = bytes.charCodeAt(n)
      }
      return new File([ia], fileName, { type: mime })
    },

    handleMiniUpload (file) {
      console.log(file)
      const res = file.response
      if (res.code === 200) {
        this.avatar = res.data.resUrl
        this.avatarResId = res.data.resId

        this.$refs.avatarUpload.removeFile(file)

        this.loadingToast.hide()
      } else {
        this.$createToast({
          txt: '上传失败：' + res.msg,
          type: 'txt'
        }).show()

        this.$refs.avatarUpload.removeFile(file)
      }
    },

    inputName () {
      this.dialog = this.$createDialog({
        type: 'prompt',
        title: '设置昵称',
        prompt: {
          value: '',
          placeholder: '请输入昵称'
        },
        onConfirm: (e, promptValue) => {
          this.userName = promptValue
        }
      }).show()
    },
    init () {
      if (this.bInit) return

      this.getData()
      this.bInit = true
    },
    getData () {
      console.log('userInfo  getData  this.init=' + this.bInit)

      queryUserDetail({}).then((res) => {
        this.userName = res.data.name
        this.birthday = res.data.birthday
        this.sexValue = res.data.sexCode === '0' ? '男' : '女'
        this.avatar = res.data.avatar
      })
    },

    justGoBack () {
      this.$router.go(-1)
    },

    headGoBack () {
      const userInfo = {
        name: this.userName,
        birthday: this.birthday
      }
      if (this.sexValue === '男') {
        userInfo['sexCode'] = '0'
      } else if (this.sexValue === '女') {
        userInfo['sexCode'] = '1'
      }
      if (this.avatarResId != null && this.avatarResId !== '' && this.avatarResId > 0) {
        userInfo['avatar'] = {
          resId: parseInt(this.avatarResId)
        }
      }
      console.log('setUserInfo userInfo' + JSON.stringify(userInfo))

      updateUserInfo(userInfo).then((res) => {
        if (this.$route.query.platform === 'mini') {
          this.$createToast({
            txt: '修改成功',
            type: 'txt'
          }).show()
        }

        this.$router.go(-1)
      })

      console.log('headGoBack')
    },
    imageAdd (data) {
      console.log('userInfo  imageAdd     resId=' + data.resId + '  url=' + data.resUrl)
      this.avatar = data.resUrl
      this.avatarResId = data.resId
    }
  }
}
</script>

<style lang="stylus" scoped>
.userInfo
  .line
    height: 1px;
    background: rgba(221, 221, 221, 1);
    margin-left: 15px;
  .arrow
    width: 9px;
    height: 15px;
  .info-block
    background-color: #ffffff;
  .bar
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    padding-left: 15px;
    padding-right: 15px;
    > div
      display flex
      align-items center
    .bar-title
      color #545454
      font-size 16px
    .value
      margin-right: 15px;
    .head-arrow
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .headImg
        margin-right: 15px;
        height: 45px;
        width: 45px;
        border-radius: 50%;
  .head
    height: 75px;
    margin-top: 10px;
    margin-bottom: 10px;
  .normal
    height: 49px;
  .password
    margin-top: 10px;
.fixed-button
  position: fixed;
  bottom: 0px;
  height: 49px;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #545454;
  .conversion-button
    background-color: #662C85;
    height: 49px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 17px;
.cube-upload
  position absolute
  left 0
  top 0
  bottom 0
  right 0
  opacity 0
  /deep/ div
    margin-right: 0;
    width: 100%;
    height: 100%;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
